module.exports = __webpack_public_path__ + "static/media/Icon-info-blue-solid.f4d30696.svg";